// extracted by mini-css-extract-plugin
export default {"Ul":"Footer_Ul__1QkLG"};